import { Color } from 'src/theme/color';
import { ISocials } from '../pages/User/UserHeader/editSocials';

export const STRING_PLACEHOLDER = '…';

export const trimAddress = (address: string, to = 6, from = 38) =>
	`${address.toString().slice(0, to)}…${address.toString().slice(from)}`;

export const trimTransactionId = (id: string) => trimAddress(id, 6, 62);

export const getTrimmedString = (ifLongerThan: number, target: string) => {
	return target.length > ifLongerThan ? `${target.substring(0, ifLongerThan)}…` : target;
};

export const noScroll = {
	'&::-webkit-scrollbar': {
		display: 'none',
	},
	'&::-webkit-scrollbar-track': {
		display: 'none',
	},
	'&::-webkit-scrollbar-thumb': {
		display: 'none',
	},
};

export const smallColorScroll = (bg: string) => ({
	'&::-webkit-scrollbar': {
		width: '5px',
		backgroundColor: Color.BACKGROUND_LIGHT,
		borderRadius: '5px',
	},
	'&::-webkit-scrollbar-thumb': {
		borderRadius: '5px',
		backgroundColor: bg,
	},
});

const hexToRgb = (color: string) => [
	parseInt(color.slice(1, 3), 16),
	parseInt(color.slice(3, 5), 16),
	parseInt(color.slice(5, 7), 16),
];

const _luminance = (r: number, g: number, b: number) => {
	const a = [r, g, b].map(v => {
		v /= 255;
		return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
	});
	return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

/**
 * Returns values from range 1-21; the greater, the better.
 */
export const colorContrast = (color1: number[] | string, color2: number[] | string) => {
	const rgb1 = typeof color1 === 'string' ? hexToRgb(color1) : color1;
	const rgb2 = typeof color2 === 'string' ? hexToRgb(color2) : color2;

	const lum1 = _luminance(rgb1[0], rgb1[1], rgb1[2]);
	const lum2 = _luminance(rgb2[0], rgb2[1], rgb2[2]);
	const brightest = Math.max(lum1, lum2);
	const darkest = Math.min(lum1, lum2);
	return (brightest + 0.05) / (darkest + 0.05);
};

export const defaultSocials = { discord: '', facebook: '', telegram: '', twitch: '', twitter: '', youtube: '' };

export const parseSocials = (socialsRaw: string): ISocials => {
	if (!socialsRaw || socialsRaw === 'null') {
		return defaultSocials;
	}

	try {
		return JSON.parse(socialsRaw);
	} catch (e) {
		return defaultSocials;
	}
};

/**
 * value                decimal places
 * [0, 0.0009]            full
 * [0.001, 0.999]        2
 * [1.00, 999.99]       2
 * [1000.0, 99999.9]    1
 * [100000, +inf]       0
 * @param balance input string
 */
export const trimBalance = (balance: string) => {
	const numericApproximation = parseFloat(balance);

	const decimalSeparatorIndex = balance.indexOf('.');

	if (numericApproximation >= 0 && numericApproximation < 0.001) {
		return balance;
	}
	if (numericApproximation >= 0.001 && numericApproximation < 1) {
		return balance.substring(0, decimalSeparatorIndex + 3);
	}
	if (numericApproximation >= 1 && numericApproximation < 1000) {
		return balance.substring(0, decimalSeparatorIndex + 3);
	}
	if (numericApproximation >= 1000 && numericApproximation < 100000) {
		return balance.substring(0, decimalSeparatorIndex + 2);
	}
	if (numericApproximation >= 100000) {
		return balance.substring(0, decimalSeparatorIndex);
	}

	return balance;
};

export const navigateToChromeStore = () => {
	// @ts-ignore
	window
		.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn', '_blank')
		.focus();
};

export const navigateToRampNetwork = () => {
	// @ts-ignore
	window.open('https://ramp.network/buy/?defaultAsset=MATIC_USDC', '_blank').focus();
};

export const formatUsd = (amount: string | number) => `$${Number(amount).toFixed(2)}`;

export const CHAKRA_MAX_WIDTH_MOBILE = `(max-width: 1167px)`;

export const nFormatter = (num: number, digits: number) => {
	const lookup = [
		{ value: 1, symbol: '' },
		{ value: 1e3, symbol: 'k' },
		{ value: 1e6, symbol: 'M' },
		{ value: 1e9, symbol: 'G' },
		{ value: 1e12, symbol: 'T' },
		{ value: 1e15, symbol: 'P' },
		{ value: 1e18, symbol: 'E' },
	];
	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	const item = lookup
		.slice()
		.reverse()
		.find(function (item) {
			return num >= item.value;
		});
	return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
};
